import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { InventoryChangeType, State } from '../../state';
import './CurrentInventoryView.css';

interface CurrentInventoryViewProps {
  valueToEdit: number
}

const CurrentInventoryView: FC<CurrentInventoryViewProps> = ({valueToEdit}:CurrentInventoryViewProps) => {

  const { inventoryState } = useSelector((state: State) => state)

  const calculateValue = ():string => {
    if (valueToEdit === 0) {
      return ""
    }
    if (inventoryState.changeType === InventoryChangeType.Adjust) {
      const newValue = Math.min(valueToEdit, 36)
      return `${newValue}`
    } else if (inventoryState.changeType === InventoryChangeType.Restock) {
      const newValue = Math.min(inventoryState.inventory + valueToEdit, 36)
      return `${newValue}`
    }
    return ""
  }

  return (
    <div className="CurrentInventoryView">
      <div className="background-container">
        <div className="bg-image" />
      </div>
      <div className="content-container">
        <div className="current-inventory value-container left">
          {inventoryState.inventory}
          <div className="label">Current number of sutures</div>
        </div>
        <div className="connector" />
        <div className="inventory-to-update value-container right">
          {calculateValue()}
          <div className="label">NEW number of sutures</div>
        </div>
      </div>
    </div>
  )
};

export default CurrentInventoryView;
